export default {
	type: 'object',
	properties: {
		gamePlatforms: {
			type: 'array',
		},
	},
}
